class TrackMyOrderService {
    constructor(restangular) {
        this.api = restangular.one('TrackMyOrder');
        this.restangular = restangular;
    }

    getOrders() {
        return this.api.get();
    }

    getOrderInfo(orderId) {
        return this.restangular.one('TrackMyOrder', orderId).get().then(response => response);
    }
}

TrackMyOrderService.$inject = ['Restangular'];

module.exports = TrackMyOrderService;



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/trackmyorder.service.js